// extracted by mini-css-extract-plugin
export default {"external":"aW8QBy","wrapper":"bW8QBy","fullHeight":"cW8QBy","link":"dW8QBy","image":"eW8QBy","headline":"fW8QBy"};